import { AssessmentResult } from 'core/completion/types'

export type SelfAssessmentParams = {
  assess?: AssessStatus | string
  comment?: string
}

export type QueryParams = {
  resultId?: Guid
}

export type RouteParams = {
  competenceId: Guid
  assessmentId: Guid
}

export type SelfAssessmentDetailsResponse = {
  id: Guid
  result: Nullable<AssessmentResult>
}

export enum AssessStatus {
  Approved = 'APPROVED',
  Disapproved = 'DISAPPROVED',
}

export type AssessmentPerform = {
  assessmentId: Guid
}
